import AlertIcon from '@components/alerticon';
import { ModalContent } from 'interface';

export const bchQualify = () => {
  return {
    icon: <AlertIcon />,
    title: 'You can only place a Business Contract Hire order with us if:',
    message: (
      <>
        <ul data-testid="bchqualify-message-list">
          <li>You are the director of a Private Limited Company</li>
          <li>The company has been trading for 3 years or more; and</li>
          <li>You are a permanent resident in mainland GB*.</li>
        </ul>
        <p>Is that you?</p>
      </>
    ),
  } as ModalContent;
};
